export default [
    {
      name: 'ManageDevices',
      title: 'Manage Devices',
      icon: 'mdi-axis',
    }
]
